import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-insider_marketing_page_tooltip_my_team_cta-click';
/**
 * My team cta click for the insider marketing page tooltip
 */
export function trackRetailerTeamManagementInsiderMarketingPageTooltipMyTeamCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
